<template>
  <span v-if="!isLoading">
    <b-button
      v-if="!dataLoad"
      variant="link"
      class="excel-btn d-inline-flex align-items-center"
      @click="confirmExportExcel"
    >
      <feather-icon
        icon="DownloadCloudIcon"
        size="14"
        class="mr-50"
      />
      <span class="text-nowrap">Export Excel</span>
    </b-button>
  </span>
  <span
    v-else
    class="d-flex align-items-center justify-content-center"
  >
    <b-spinner label="Preparing Excel..." />
  </span>
</template>
<script>

import axios from 'axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  props: {
    dataLoad: {
      type: Boolean,
      default: () => false,
    },
    paramExel: {
      type: Object,
      default: () => {},
    },
    columns: {
      type: Array,
      default: () => [],
    },
    apiUrl: {
      type: String,
      default: () => '',
    },
  },
  data() {
    return {
      isLoading: false,
    }
  },

  methods: {
    confirmExportExcel() {
      this.$swal({
        title: 'Export to Excel?',
        text: 'The file will be generated using the current filters and downloaded to your device.',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Export',
        cancelButtonText: 'Cancel',
        confirmButtonColor: '#7367f0',
        cancelButtonColor: '#82868b',
        width: 520,
      }).then(result => {
        if (result.isConfirmed) {
          this.makeSheetExcelRequest()
        }
      })
    },

    async makeSheetExcelRequest() {
      this.isLoading = true
      const headersInParams = this.columns.map(column => column.key).join(',')

      const newParamsExcel = Object.fromEntries(
        Object.entries(this.paramExel).filter(([key, value]) => key !== 'skip' && value != null),
      )
      try {
        const response = await axios.get(this.apiUrl, {
          params: {
            excel: 1,
            headers: headersInParams,
            ...newParamsExcel,
          },
          responseType: 'blob',
        })

        if (response.status === 200) {
          const now = new Date()
          const formattedDate = now.toISOString().split('T')[0]
          const formattedTime = now.toTimeString().split(' ')[0].replace(/:/g, '-')
          const dateTimeString = `request ${formattedDate}_${formattedTime}`

          const blob = new Blob([response.data], { type: response.data.type })
          const url = window.URL.createObjectURL(blob)

          const link = document.createElement('a')
          link.href = url
          link.download = dateTimeString
          link.click()

          this.$toasted.show('Updated Successfully', {
            position: 'top-center',
            duration: 3000,
          })
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `${error}`,
            icon: 'BellIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.isLoading = false
      }
    },

  },
}
</script>

<style scoped lang="scss">
.excel-btn {
  border-radius: 999px;
  padding: 0.3rem 0.8rem;
  font-size: 0.8rem;
  font-weight: 600;
  color: inherit !important;
  background: transparent !important;
  border: none;
}
</style>
